export default "__VITE_ASSET__BG_x1ae3__"